import { createContext } from 'react';
import type { useNotificationsProvider } from './useNotificationsProvider.ts';

type NotificationsContextValue = ReturnType<typeof useNotificationsProvider>;

/**
 * {@link NotificationsContext} tracks global notification state.
 */
export const NotificationsContext = createContext<NotificationsContextValue | undefined>(undefined);
